import { Component, OnInit } from '@angular/core';
import { faCheckCircle, faEdit, faEye, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import {LookupService} from 'src/app/share/services/lookup/lookup.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { CommonService } from 'src/app/share/services/common/common.service';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { ConfirmationPopupComponent } from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';

@Component({
    selector: 'app-workflow-list',
    templateUrl: './workflow-list.component.html',
    styleUrl: './workflow-list.component.scss',
    standalone: false
})
export class WorkflowListComponent implements OnInit {
  faEye: any = faEye;
  faEdit: any = faEdit;
  faTrashCan: any = faTrashCan;
  faCheckCircle: any = faCheckCircle
  isPanelOpen: boolean = false;
  panelMode: 'create' | 'update' | 'view' = 'create';
  workflowList: any = [];
  selectedWorkflow: any = null;
  selfDetails: any = null;
  isLoadRecords: boolean = false;
  totalWorkflowCount: number = 0;
  paginationParams: any = {
    page: 0,
  }
  showSuccessToaster: boolean = false;
  showErrorToaster: boolean = false;
  toasterMessage: string = '';
  preference: any = null;
  isOpenOrganizationStructure: boolean = false;
  previousCompanyId: string = '';
  selectedCompany: any = null;
  activeCompanyId: string = '';
  viewLoading : boolean = false;
  editLoading : boolean = false;

  constructor(
    private readonly lookupService: LookupService,
    private readonly modal: NgbModal,
    private readonly storageService: StorageService,
    public readonly commonService: CommonService

  ) {

  }


  ngOnInit(): void {
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.activeCompanyId = this.selfDetails?.company ;
    this.getWorkflowCount();
    this.getWorkflowList();
  }

  getWorkflowList() {
    let params = {
      ...this.paginationParams,
    }
    this.isLoadRecords = true;
    this.lookupService.getWorkflows(this.activeCompanyId, params).subscribe({
      next: (res: any) => {
        this.isLoadRecords = false;
        this.workflowList = res.data;
        this.workflowList = this.workflowList.map((workflow: any) => {
          return {
            ...workflow,
            time: new Date()
          }
        });
      },
      error: (err) => {
        console.error('Error fetching workflows:', err);
      }
    })
  }

  getWorkflowCount() {
    let params = {};
    this.lookupService.getWorkflowCount(this.activeCompanyId, params).subscribe({
      next: (res: any) => {
        this.totalWorkflowCount = res?.data?.count || 0;
      },
      error: (err) => {
        console.error('Error fetching workflow count:', err);
      }
    })
  }

  deleteWorkflow(workflow: any) {

    let confirmationPopup = this.modal?.open(ConfirmationPopupComponent, {
      backdrop: 'static',
      size: 'md',
      keyboard: false,
      centered: true,
    })

    if (confirmationPopup?.componentInstance) {
      confirmationPopup.componentInstance.message = `Do you want to Deactivate this workflow ${workflow?.name}`;
      confirmationPopup.componentInstance.lableName = 'Confirm';
      confirmationPopup.componentInstance.isConfirmationMessage = false;
      confirmationPopup.componentInstance.isConfirmationMessageRequired = false;
      confirmationPopup.result.then((result: any) => {
        if (result) {
          this.lookupService.deleteWorkflow(this.activeCompanyId, workflow._id).subscribe({
            next: (res) => {
              this.getWorkflowList();
              this.showSuccessToaster = true;
              this.toasterMessage = 'Workflow deleted successfully';
            },
            error: (err) => {
              this.workflowList = [...this.workflowList];
              this.showErrorToaster = true;
              this.toasterMessage = err?.error?.error?.message ? err?.error?.error?.message : 'Error deleting workflow';
            }
          });
        } else {
          workflow.time = new Date()
          this.workflowList = [...this.workflowList];
        }
      })
    }
  }


  ActivateWorkflow(workflow: any) {

    let confirmationPopup = this.modal?.open(ConfirmationPopupComponent, {
      backdrop: 'static',
      size: 'md',
      keyboard: false,
      centered: true,
    })

    if (confirmationPopup?.componentInstance) {
      confirmationPopup.componentInstance.message = `Do you want to Activate this workflow ${workflow?.name}`;
      confirmationPopup.componentInstance.lableName = 'Confirm';
      confirmationPopup.componentInstance.isConfirmationMessage = false;
      confirmationPopup.componentInstance.isConfirmationMessageRequired = false;
      confirmationPopup.result.then((result: any) => {
        if (result) {
          this.lookupService.activateWorkflow(this.activeCompanyId, workflow._id).subscribe({
            next: (res: any) => {
              this.getWorkflowList();
              this.showSuccessToaster = true;
              this.toasterMessage = 'Workflow activated successfully';
            },
            error: (err : any) => {
              this.showErrorToaster = true;
              this.toasterMessage = err?.error?.error?.message ? err?.error?.error?.message : 'Error Activating workflow';
            }
          });
        }
      })
    }
  }


  closeManagePanel(event: any) {
    if (event.isClose) {
      this.isPanelOpen = false;
    } else if (event.mode === 'Update') {
      this.getWorkflowList();
      this.isPanelOpen = false;
      this.showSuccessToaster = true;
      this.toasterMessage = 'Workflow updated successfully';
    } else if (event.mode === 'Create') {
      this.getWorkflowList();
      this.isPanelOpen = false;
      this.showSuccessToaster = true;
      this.toasterMessage = 'Workflow created successfully';
    }
  }

  handlePaginationPageChange(event: any) {
    this.paginationParams.page = event.page;
    this.getWorkflowList();
  }

  editWorkflow(workflow: any) {
    this.editLoading = true;
    this.selectedWorkflow = workflow;
    this.isPanelOpen = true;
    this.panelMode = 'update';
    this.editLoading = false;
  }

  viewWorkflow(workflow: any) {
    this.viewLoading = true;
    this.selectedWorkflow = workflow;
    this.isPanelOpen = true;
    this.panelMode = 'view';
    this.viewLoading = false;
  }

  closeToaster() {
    this.showSuccessToaster = false;
    this.showErrorToaster = false;
    this.toasterMessage = '';
  }

  openOrganizationStructure(value: any) {
    this.previousCompanyId = value.company;
    document.body.classList.add('panel-open');
    this.isOpenOrganizationStructure = true;
  }


  selectedOrgOnSearch(data: any) {
    if (data?.length) {
      this.selectedCompany = data[0];
      this.activeCompanyId = data[0]?._id;
      this.getWorkflowCount();
      this.getWorkflowList();
    }
  }

  closeOrganizationStructureOverlay() {
    document.body.classList.remove('panel-open');
    this.isOpenOrganizationStructure = false;
  }

  selectedOrgOnStructure(data: any) {
    this.selectedCompany = data;
    this.activeCompanyId = data?._id;
    this.getWorkflowCount();
    this.getWorkflowList();
  }

  removeSelectedCompany() {
    this.selectedCompany = null;
    this.activeCompanyId = this.selfDetails?.company;
    this.getWorkflowCount();
    this.getWorkflowList();
  }

  hasEditAccess(workflow: any): boolean {
    if (!this.commonService.hasAllowedAction()) {
      return false;
    }
    return workflow?.visibleTo?.includes(this.selfDetails?.company);
  }

}
